import {InfoWindowF} from "@react-google-maps/api";
import PropTypes from "prop-types";
import {useEffect, useRef, useState} from "react";
import {OrganizationCardMemo} from "../../OrganizationCard/OrganizationCard.jsx";
import { useFindOrganizationsMapStore } from "../store.jsx";
import { useOnClickOutside } from "usehooks-ts";
import s from "./TFInfoBox.module.css";
import classNames from "classnames";

export default function TFInfoBox({ item }) {
    const containerRef = useRef(null);
    const [offset, setOffset] = useState(null);
    const selectedItem = useFindOrganizationsMapStore(
        (state) => state.selectedItem,
    );
    const setSelectedItem = useFindOrganizationsMapStore(
        (state) => state.setSelectedItem,
    );
    
    const updateObserver = new MutationObserver((mutations) => {
        const {width, height} = containerRef.current.getBoundingClientRect();
        setOffset(getOffset({width, height}));
    });

    const currentPage = useFindOrganizationsMapStore(
        (state) => state.currentPage,
    );

    const grouped = useFindOrganizationsMapStore((state) => state.markerGroups);

    const renderGrouped = grouped.length > 1;
    const itemToRender = renderGrouped
        ? grouped[currentPage - 1]
        : selectedItem;
    
    const [infoWindow, setInfoWindow] = useState(null);

    const getOffset = ({width, height}) => {
        return new window.google.maps.Size(
            -width / 2,
            height + 30,
        );
    };

    const getPostion = () => {
        if (!itemToRender) return;
        if (!itemToRender.geoLocation?.latitude || !itemToRender.geoLocation?.longitude) return;
        
        return new window.google.maps.LatLng(
            itemToRender.geoLocation.latitude,
            itemToRender.geoLocation.longitude,
        );
    };
    
    const resetItem = () => setSelectedItem(null);

    useOnClickOutside(containerRef, () => setSelectedItem(null));
    useEffect(() => {
        if (containerRef.current) {
            updateObserver.observe(containerRef.current, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
            const { width, height } = containerRef.current.getBoundingClientRect();
            setOffset(getOffset({ width, height }));
            infoWindow?.setOptions({ pixelOffset: getOffset({ width, height }) });
        }
    }, [containerRef.current]);

    const render = 
        itemToRender?.geoLocation?.latitude &&
        itemToRender?.name === selectedItem?.name &&
        itemToRender?.geoLocation?.longitude;
    
    const options = {
        closeBoxURL: "",
        pixelOffset: offset
    }

    return (
        render && (
            <InfoWindowF
                options={options}
                onLoad={(infoWindow) => setInfoWindow(infoWindow)}
                onUnmount={() => setInfoWindow(null)}
                onCloseClick={resetItem}
                position={getPostion()}
            >
                <div className={classNames(s.root, { [s.hidden]: !offset })}
                     ref={containerRef}>
                    <OrganizationCardMemo
                        organization={itemToRender}
                        showDirectionsLink={true}
                        cardHandler={resetItem}
                        grouped={grouped}
                        from={"TFInfoBox"}
                    />
                </div>
            </InfoWindowF>
        )
    );
}

TFInfoBox.propTypes = {
    item: PropTypes.object,
};
